@if (isImpersonating()) {
  <div class="fixed top-0 left-0 z-[1030] h-10 w-full flex items-center justify-center gap-3 px-4 bg-(--surface-card) text-sm">
    <i class="fa-solid fa-user-secret text-warning"></i>
    <span>
      {{ 'impersonation.banner.viewingAs' | translate: { name: (currentUser().name || '') + ' ' + (currentUser().surname || ''), email: currentUser().email } }}
    </span>
    <p-button
      [text]="true"
      size="small"
      severity="warn"
      [label]="'impersonation.banner.return' | translate"
      icon="fa-solid fa-right-to-bracket"
      (onClick)="exitViewAs()"
    />
  </div>
}
